module.exports = __webpack_public_path__ + "6b599f59fea950c1149ed9acdebf36d5.png";